import { useReducer } from 'react'
import { deepCopy, formatEventValue } from '../fns'

const formReducer = (state, action) => {
  switch (action.type) {
    case 'form/setFieldValue': {
      const updatedFormValues = { ...state.values, ...action.payload }

      return { ...state, values: updatedFormValues }
    }
    case 'form/setFieldTouched': {
      const updatedTouchedValues = { ...state.touched, ...action.payload }

      return { ...state, touched: updatedTouchedValues }
    }
    case 'form/initFormValues': {
      const formTouched = deepCopy(action.payload)
      Object.keys(formTouched).forEach((key) => (formTouched[key] = false))

      return {
        values: action.payload,
        touched: formTouched,
      }
    }
    default:
      return { ...state }
  }
}

export const useForm = (initialFormValues = {}) => {
  const [state, dispatch] = useReducer(formReducer, initialFormValues, (values) => {
    const formTouched = deepCopy(values)
    Object.keys(formTouched).forEach((key) => (formTouched[key] = false))

    return {
      values,
      touched: formTouched,
    }
  })

  const onChange = (e) => {
    const formattedValue = formatEventValue(e.target)
    dispatch({ type: 'form/setFieldValue', payload: { [e.target.name]: formattedValue } })
  }

  const resetForm = (payload) => {
    dispatch({ type: 'form/initFormValues', payload })
  }

  const setFieldValue = (fieldName, value) => {
    dispatch({ type: 'form/setFieldValue', payload: { [fieldName]: value } })
  }

  const setFieldTouched = (fieldName, isTouched = false) => {
    dispatch({ type: 'form/setFieldTouched', payload: { [fieldName]: isTouched } })
  }

  const onBlur = (e) => {
    setFieldTouched(e.target.name, false)
  }

  const onFocus = (e) => {
    setFieldTouched(e.target.name, true)
  }

  return {
    ...state,
    onChange,
    onBlur,
    onFocus,
    setFieldValue,
    resetForm,
  }
}
